import { render, staticRenderFns } from "./TreatmentPlanRequestCancelModal.vue?vue&type=template&id=0bbad6d3&scoped=true&"
import script from "./TreatmentPlanRequestCancelModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequestCancelModal.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequestCancelModal.vue?vue&type=style&index=0&id=0bbad6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbad6d3",
  null
  
)

export default component.exports